import { useClearFilters } from '@/src/hooks/srp/clearFilters'
import useStopFilterManager from '@/src/hooks/srp/stopFilterManager'
import { TranslationFunction } from '@/src/types/translations'
import { Box } from '@mui/material'
import React from 'react'
import FloatingFilterBar from './floatingFilterBar'

interface SrpFilterAndSortTabBarProps {
    onFilterClick?: () => void
    onSortClick?: () => void
    t: TranslationFunction<'common'>
}

const SrpFilterAndSortTabBar: React.FC<SrpFilterAndSortTabBarProps> = ({ onFilterClick, onSortClick, t }) => {
    const { nonStopToggle, nonStopChecked, isNonstopFlightAvailable: showNonstopToggle } = useStopFilterManager()
    const { numberOfFiltersApplied } = useClearFilters()

    return (
        <Box sx={{ width: '100%' }}>
            <FloatingFilterBar
                filtersCount={numberOfFiltersApplied || 0}
                nonStopEnabled={showNonstopToggle}
                nonStopChecked={!!nonStopChecked}
                onFilterClick={onFilterClick}
                onSortClick={onSortClick}
                onNonStopClick={nonStopToggle}
                filterLabel={t('filter')}
                sortLabel={t('sort')}
                nonStopLabel={t('direct')}

            />
        </Box>
    )
}

export default SrpFilterAndSortTabBar
